import { Module } from 'vuex';
import { RootState } from '@/store/types';
import { StatisticState } from './types';

import { actions } from './actions';
import { mutations } from './mutations';
import { getters } from './getters';

export const state: StatisticState = {
  emailStatisticDetail: [],
  emailStatisticDetailFlag: null,
  emailStatisticGroup: [],
  emailStatisticGroupEvents: {},
  emailMessageCount: 0,
  emailGroupings: {
    emailGroup: [
      'hour',
      'day',
      'week',
      'month',
    ],
    emailGroupByOptionally: [
      'partner',
      'service_provider',
      'originator',
      'template_id',
      'bulk_id',
      'broker_account_login',
      'message_type',
    ],
    emailGroupEventsByOptionally: [
      'partner',
      'service_provider',
      'originator',
      'template_id',
      'bulk_id',
      'broker_account_login',
      'message_type',
      'receiver'
    ],
    emailGroupIncoming: [

    ],
  },
  emailDetailEvents: [],
  emailDetailEventsInfo: {}
};

export const emailStatistic: Module<StatisticState, RootState> = {
  state,
  getters,
  actions,
  mutations,
};
